import RoofRange from "./RoofRange";
import { Statics } from "../utilities/statics";
import { Global } from "../utilities/global";
import { SC_Input } from "../input/SC_Input";
import { Point } from "../area/Point";
import * as konva from "../konva/getCanvas";
import Konva from "konva";
import { Modul } from "../panel/Modul";
import { ModulProp } from "../panel/ModulProp";
import { Sol50OnRoof } from "../mountsys/Sol50OnRoof";
import { Sol50Integrated } from "../mountsys/Sol50Integrated";
import { Sol50 } from "../mountsys/Sol50";
import { ScaleAdjustmentValue } from "../getScaleFactor";
import { DrawRoofForPanel } from '../panel/drawRoofForPanel';
import { getCanvasLine } from "../konva/getCanvas";
import { PanelAutofillArea } from '../input/PanelAutofillArea';
import DrawPanels from "../konva/drawPanels";

export class Rectangular {
     static rrFTopLeft: RoofRange;
     static rrFTopRight: RoofRange;
     static rrFBottomLeft: RoofRange;
     static rrFBottomRight: RoofRange;
     static rrFTopLeftV: RoofRange;
     static rrFTopRightV: RoofRange;
     static rrFBottomLeftV: RoofRange;
     static rrFBottomRightV: RoofRange;
     static rrGLeft: RoofRange;
     static rrGTop: RoofRange;
     static rrGBottom: RoofRange;
     static rrGRight: RoofRange;
     static nRoofHeight: number;
     static nRoofWidth: number;
     static nE10Ver: number;
     static nE10Side: number;
     static areaHtopLeft: Point;
     static areaHtopRight: Point;
     static areaHbottomLeft: Point;
     static areaHbottomRight: Point;
     nE4Ver: number;
     nE4Side: number;
     nHHeight: number;
     nHWidth: number;
     nZusatzHeight: number = 20;
     // commented due to Errors
     public fitRectInroof(): void {
          var panelTmp: Modul;
          var i: number, j: number;
          var nMaxW: number, nCurY: number;
          var nCenterVal: number;
          var nModWidth: number, nModHeight: number;
          var iMaxCol: number;
          var iMaxRow: number;
          var nStartY: number;
          var nMaxGenWidth: number;
          var nMaxGenHeight: number;
          var nCurX: number;

          if (SC_Input.iModAlignment == ModulProp.ORIENTATION_HORIZONTAL) {
               nModWidth = SC_Input.nModHeight / 10;
               nModHeight = SC_Input.nModWidth / 10;
          } else {
               nModWidth = SC_Input.nModWidth / 10;
               nModHeight = SC_Input.nModHeight / 10;
          }
          // Modul.width = nModWidth;
          // Modul.height = nModHeight;

          nMaxGenWidth = Rectangular.nRoofWidth - (Sol50Integrated.nRandLeftRight + Rectangular.nE10Side * 2);
          nMaxGenHeight = Rectangular.nRoofHeight - (Sol50Integrated.nEindeckblechZusatz / 2 + Sol50Integrated.nRandTop + this.nZusatzHeight + Rectangular.nE10Ver * 2);
          nStartY = Sol50Integrated.nRandTop + this.nZusatzHeight + Rectangular.nE10Ver;
          iMaxCol = Sol50.calcCols(nMaxGenWidth, nModWidth);
          iMaxRow = Sol50.calcRowsFromHeight(nMaxGenHeight, nModHeight);
          nCenterVal = iMaxCol * (nModWidth + Sol50.nHorizontalAbstand) - Sol50.nHorizontalAbstand;
          nCenterVal = (Rectangular.nRoofWidth - nCenterVal) / 2;
          const allPanels: any = [];
          for (i = 0; i < iMaxRow; i++) {
               nCurY = nStartY + (i * (nModHeight + Sol50.nVertikalAbstand));
               for (j = 0; j < iMaxCol; j++) {
                    var x = ((nModWidth + Sol50.nHorizontalAbstand) * j) + nCenterVal;
                    var y = nCurY;
                    allPanels.push({x: ScaleAdjustmentValue.getScaleAdjust(x), y: ScaleAdjustmentValue.getScaleAdjust(y), w: nModWidth, h:nModHeight});
                    // panelTmp = new Modul(ScaleAdjustmentValue.getScaleAdjust(x), ScaleAdjustmentValue.getScaleAdjust(y), nModWidth, nModHeight);
                    // panelTmp.draw(DrawRoofForPanel.panelGroup);
               }
          }
          new DrawPanels().drawPanels(allPanels);

          // if(SC_Input.iPnlFillArea == PanelAutofillArea.INNER) {
          //   nE10Side = Statics.getE10(nRoofHeight, SC_Input.iBuilding);
          //   nE10Ver = Statics.getE10(nRoofWidth, SC_Input.iBuilding);
          //   nMaxGenWidth = nRoofWidth - (Sol50Integrated.nRandLeftRight + nE10Side * 2);
          //   nMaxGenHeight = nRoofHeight - (Sol50Integrated.nEindeckblechZusatz / 2 + Sol50Integrated.nRandTop + nZusatzHeight+ nE10Ver * 2);
          //   nStartY = Sol50Integrated.nRandTop + nZusatzHeight + nE10Ver;
          // } else {
          //   nMaxGenWidth = nRoofWidth - Sol50Integrated.nRandLeftRight;
          //   nMaxGenHeight = nRoofHeight - (Sol50Integrated.nEindeckblechZusatz / 2 + Sol50Integrated.nRandTop + nZusatzHeight);
          //   nStartY = Sol50Integrated.nRandTop + nZusatzHeight;
          // }
          // iMaxCol = Sol50.calcCols(nMaxGenWidth, nModWidth);
          // iMaxRow = Sol50.calcRowsFromHeight(nMaxGenHeight, nModHeight);
          // nCenterVal = iMaxCol * (nModWidth + Sol50.nHorizontalAbstand) - Sol50.nHorizontalAbstand;
          // nCenterVal = (nRoofWidth - nCenterVal) / 2;
          // for(i = 0; i < iMaxRow; i++) {
          //   nCurY = nStartY + (i * (nModHeight + Sol50.nVertikalAbstand));
          // //                    nDifLeft = nWingFactor * nCurY;
          //   for(j = 0; j < iMaxCol; j++) {
          //        modulTmp = new Modul(nModWidth, nModHeight);
          //        modulTmp.x = ((nModWidth + Sol50.nHorizontalAbstand) * j) + nCenterVal;
          //        modulTmp.y = nCurY;
          //        modulTmp.draw();
          //        Global.pageDesign.canMod.addChild(modulTmp);
          //   }
          // }
     }

     public fitRect(): void {
          var panelTmp: Modul;
          var i: number, j: number;
          var nMaxW: number, nCurY: number;
          var nCenterVal: number;
          var nPanelWidth: number, nPanelHeight: number;
          var iMaxCol: number;
          var iMaxRow: number;
          var nStartY: number;
          var nMaxGenWidth: number;
          var nMaxGenHeight: number;
          var nCurX: number;

          if (SC_Input.iModAlignment == ModulProp.ORIENTATION_HORIZONTAL) {
               nPanelWidth = SC_Input.nModHeight / 10;
               nPanelHeight = SC_Input.nModWidth / 10;
          } else {
               nPanelWidth = SC_Input.nModWidth / 10;
               nPanelHeight = SC_Input.nModHeight / 10;
          }
          // Modul.width = nPanelWidth;
          // Modul.height = nPanelHeight;
          var nE10Side = Statics.getE10(Rectangular.nRoofHeight, SC_Input.iBuilding * 100);
          var nE10Ver = Statics.getE10(Rectangular.nRoofWidth, SC_Input.iBuilding * 100);
          nMaxGenWidth = Rectangular.nRoofWidth - (Sol50OnRoof.nRandLeftRight + nE10Side * 2);
          nMaxGenHeight = Rectangular.nRoofHeight - (Sol50OnRoof.nRandTop + Sol50OnRoof.nRandBottom + nE10Ver * 2);
          nStartY = Sol50OnRoof.nRandTop + nE10Ver;
          if (SC_Input.iPnlFillArea == PanelAutofillArea.ALL) {
               nMaxGenWidth = Rectangular.nRoofWidth - Sol50Integrated.nRandLeftRight;
               nMaxGenHeight = Rectangular.nRoofHeight - (Sol50Integrated.nEindeckblechZusatz / 2 + Sol50Integrated.nRandTop + this.nZusatzHeight);
               nStartY = Sol50Integrated.nRandTop + this.nZusatzHeight;
          }
          iMaxCol = Sol50.calcCols(nMaxGenWidth, nPanelWidth);
          iMaxRow = Sol50.calcRowsFromHeight(nMaxGenHeight, nPanelHeight);
          nCenterVal = iMaxCol * (nPanelWidth + Sol50.nHorizontalAbstand) - Sol50.nHorizontalAbstand;
          nCenterVal = (Rectangular.nRoofWidth - nCenterVal) / 2;
          const allPanels = [];
          for (i = 0; i < iMaxRow; i++) {
               nCurY = nStartY + (i * (nPanelHeight + Sol50.nVertikalAbstand));
               for (j = 0; j < iMaxCol; j++) {
                    var x = ((nPanelWidth + Sol50.nHorizontalAbstand) * j) + nCenterVal;
                    var y = nCurY;
                    // panelTmp = new Modul(ScaleAdjustmentValue.getScaleAdjust(x), ScaleAdjustmentValue.getScaleAdjust(y), nPanelWidth, nPanelHeight);
                    // panelTmp.draw(DrawRoofForPanel.panelGroup);
                    allPanels.push({ x: ScaleAdjustmentValue.getScaleAdjust(x), y: ScaleAdjustmentValue.getScaleAdjust(y), w: nPanelWidth, h: nPanelHeight })
               }
          }
          new DrawPanels().drawPanels(allPanels);

          // if(SC_Input.iPnlFillArea == PanelAutofillArea.INNER) {
          //   nE10Side = Statics.getE10(nRoofHeight, SC_Input.iBuilding);
          //   nE10Ver = Statics.getE10(nRoofWidth, SC_Input.iBuilding);
          //   nMaxGenWidth = nRoofWidth - (Sol50OnRoof.nRandLeftRight + nE10Side * 2);
          //   nMaxGenHeight = nRoofHeight - (Sol50OnRoof.nRandTop + Sol50OnRoof.nRandBottom + nE10Ver * 2);
          //   nStartY = Sol50OnRoof.nRandTop + nE10Ver;
          // } else {
          //   nMaxGenWidth = nRoofWidth - Sol50OnRoof.nRandLeftRight;
          //   nMaxGenHeight = nRoofHeight - (Sol50OnRoof.nRandTop + Sol50OnRoof.nRandBottom);
          //   nStartY = Sol50OnRoof.nRandTop;
          // }
          //   //             nMaxGenWidth = nRoofWidth - Sol50Aufdach.nRandLeftRight;
          //   //             nMaxGenHeight = nRoofHeight - (Sol50Aufdach.nRandTop + Sol50Aufdach.nRandBottom);
          //   //             nStartY = Sol50Aufdach.nRandTop;
          //                  iMaxCol = Sol50.calcCols(nMaxGenWidth, nPanelWidth);
          //                  iMaxRow = Sol50.calcRowsFromHeight(nMaxGenHeight, nPanelHeight);
          //                  nCenterVal = iMaxCol * (nPanelWidth + Sol50.nHorizontalAbstand) - Sol50.nHorizontalAbstand;
          //                  nCenterVal = (nRoofWidth - nCenterVal) / 2;
          //                  for(i = 0; i < iMaxRow; i++) {
          //                       nCurY = nStartY + (i * (nPanelHeight + Sol50.nVertikalAbstand));
          //   //                  nDifLeft = nWingFactor * nCurY;
          //   for(j = 0; j < iMaxCol; j++) {
          //        panelTmp = new Modul(nPanelWidth, nPanelHeight);
          //        panelTmp.x = ((nPanelWidth + Sol50.nHorizontalAbstand) * j) + nCenterVal;
          //        panelTmp.y = nCurY;
          //        panelTmp.draw();
          //        Global.pageDesign.canMod.addChild(panelTmp);
          //   }
          // }
     }
     drawRect(layer: Konva.Layer) {
          var a: number, b: number;
          a = SC_Input.a;
          b = SC_Input.b;
          Rectangular.nRoofWidth = SC_Input.b;
          Rectangular.nRoofHeight = SC_Input.a;
          Global.canRoof.width = b * Global.canRoof.scaleX;
          Global.canRoof.height = a * Global.canRoof.scaleY;
          var rectH = konva.getCanvasRect({
               x: ScaleAdjustmentValue.getScaleAdjust(0),
               y: ScaleAdjustmentValue.getScaleAdjust(0),
               width: b,
               height: a,
               fill: Global.colDach,
          });
          SC_Input.rectH = rectH;
          layer.add(rectH);
          layer.draw();

          Rectangular.nE10Side = Statics.getE10(a, SC_Input.iBuilding * 100);
          Rectangular.nE10Ver = Statics.getE10(b, SC_Input.iBuilding * 100);
          this.nE4Side = Statics.getE4(a, SC_Input.iBuilding * 100);
          this.nE4Ver = Statics.getE4(b, SC_Input.iBuilding * 100);
          Rectangular.nRoofHeight = a;
          this.createsAreas(layer);
     }

     drawPult(layer: Konva.Layer) {
          this.drawRect(layer)
     }

     drawSattel(layer: Konva.Layer) {
          this.drawRect(layer)
     }

     drawSched(layer: Konva.Layer) {
          this.drawRect(layer)
     }

     createsAreas(layer: Konva.Layer) {
          var nX: number, nY: number;
          /* F */
          //FBottomLeft
          Rectangular.rrFBottomLeft = new RoofRange(Global.colDachF);
          nX = 0;
          nY = Rectangular.nRoofHeight;
          Rectangular.rrFBottomLeft.pBottomLeft = new Point(nX, nY);

          nX = this.nE4Ver;
          nY = Rectangular.nRoofHeight;
          Rectangular.rrFBottomLeft.pBottomRight = new Point(nX, nY);

          nX = 0;
          nY = Rectangular.nRoofHeight - Rectangular.nE10Ver;
          Rectangular.rrFBottomLeft.pTopLeft = new Point(nX, nY);

          nX = this.nE4Ver;
          nY = Rectangular.nRoofHeight - Rectangular.nE10Ver;
          Rectangular.rrFBottomLeft.pTopRight = new Point(nX, nY);
          Rectangular.rrFBottomLeft.draw(layer);
          Rectangular.rrFBottomLeft.setLabel("F");

          //FBottomLeftV
          Rectangular.rrFBottomLeftV = new RoofRange(Global.colDachF);
          nX = 0;
          nY = Rectangular.nRoofHeight;
          Rectangular.rrFBottomLeftV.pBottomLeft = new Point(nX, nY);

          nX = Rectangular.nE10Side;
          nY = Rectangular.nRoofHeight;
          Rectangular.rrFBottomLeftV.pBottomRight = new Point(nX, nY);

          nX = 0;
          nY = Rectangular.nRoofHeight - this.nE4Side;
          Rectangular.rrFBottomLeftV.pTopLeft = new Point(nX, nY);

          nX = Rectangular.nE10Side;
          nY = nY;
          Rectangular.rrFBottomLeftV.pTopRight = new Point(nX, nY);
          Rectangular.rrFBottomLeftV.draw(layer);

          //FBottomRight
          Rectangular.rrFBottomRight = new RoofRange(Global.colDachF);
          nX = Rectangular.nRoofWidth - this.nE4Ver;
          nY = Rectangular.nRoofHeight;
          Rectangular.rrFBottomRight.pBottomLeft = new Point(nX, nY);

          nX = Rectangular.nRoofWidth;
          nY = Rectangular.nRoofHeight;
          Rectangular.rrFBottomRight.pBottomRight = new Point(nX, nY);

          nX = Rectangular.nRoofWidth - this.nE4Ver;
          nY = Rectangular.nRoofHeight - Rectangular.nE10Ver;
          Rectangular.rrFBottomRight.pTopLeft = new Point(nX, nY);

          nX = Rectangular.nRoofWidth;
          nY = Rectangular.nRoofHeight - Rectangular.nE10Ver;
          Rectangular.rrFBottomRight.pTopRight = new Point(nX, nY);
          Rectangular.rrFBottomRight.draw(layer);
          Rectangular.rrFBottomRight.setLabel("F");
          //FBottomRightV
          Rectangular.rrFBottomRightV = new RoofRange(Global.colDachF);
          nX = Rectangular.nRoofWidth - Rectangular.nE10Side;
          nY = Rectangular.nRoofHeight;
          Rectangular.rrFBottomRightV.pBottomLeft = new Point(nX, nY);

          nX = Rectangular.nRoofWidth;
          nY = Rectangular.nRoofHeight;
          Rectangular.rrFBottomRightV.pBottomRight = new Point(nX, nY);

          nX = Rectangular.nRoofWidth - Rectangular.nE10Side;
          nY = Rectangular.nRoofHeight - this.nE4Side;
          Rectangular.rrFBottomRightV.pTopLeft = new Point(nX, nY);

          nX = Rectangular.nRoofWidth;
          nY = Rectangular.nRoofHeight - this.nE4Side;
          Rectangular.rrFBottomRightV.pTopRight = new Point(nX, nY);
          Rectangular.rrFBottomRightV.draw(layer);

          //FTopLeft
          Rectangular.rrFTopLeft = new RoofRange(Global.colDachF);
          nX = 0;
          nY = Rectangular.nE10Ver;
          Rectangular.rrFTopLeft.pBottomLeft = new Point(nX, nY);

          nX = this.nE4Ver;
          nY = Rectangular.nE10Ver;
          Rectangular.rrFTopLeft.pBottomRight = new Point(nX, nY);

          nX = 0;
          nY = 0;
          Rectangular.rrFTopLeft.pTopLeft = new Point(nX, nY);

          nX = this.nE4Ver;
          nY = 0;
          Rectangular.rrFTopLeft.pTopRight = new Point(nX, nY);
          Rectangular.rrFTopLeft.draw(layer);
          Rectangular.rrFTopLeft.setLabel("F");

          //FTopLeftV
          Rectangular.rrFTopLeftV = new RoofRange(Global.colDachF);
          nX = 0;
          nY = this.nE4Side;
          Rectangular.rrFTopLeftV.pBottomLeft = new Point(nX, nY);

          nX = Rectangular.nE10Side;
          nY = this.nE4Side;
          Rectangular.rrFTopLeftV.pBottomRight = new Point(nX, nY);

          nX = 0;
          nY = 0;
          Rectangular.rrFTopLeftV.pTopLeft = new Point(nX, nY);

          nX = Rectangular.nE10Side;
          nY = 0;
          Rectangular.rrFTopLeftV.pTopRight = new Point(nX, nY);
          Rectangular.rrFTopLeftV.draw(layer);

          //FTopRight
          Rectangular.rrFTopRight = new RoofRange(Global.colDachF);
          nX = Rectangular.nRoofWidth - this.nE4Ver;
          nY = Rectangular.nE10Ver;
          Rectangular.rrFTopRight.pBottomLeft = new Point(nX, nY);

          nX = Rectangular.nRoofWidth;
          nY = Rectangular.nE10Ver;
          Rectangular.rrFTopRight.pBottomRight = new Point(nX, nY);

          nX = Rectangular.nRoofWidth - this.nE4Ver;
          nY = 0;
          Rectangular.rrFTopRight.pTopLeft = new Point(nX, nY);

          nX = Rectangular.nRoofWidth;
          nY = 0;
          Rectangular.rrFTopRight.pTopRight = new Point(nX, nY);
          Rectangular.rrFTopRight.draw(layer);
          Rectangular.rrFTopRight.setLabel("F");
          //FTopRightV
          Rectangular.rrFTopRightV = new RoofRange(Global.colDachF);
          nX = Rectangular.nRoofWidth - Rectangular.nE10Side;
          nY = this.nE4Side;
          Rectangular.rrFTopRightV.pBottomLeft = new Point(nX, nY);

          nX = Rectangular.nRoofWidth;
          nY = this.nE4Side;
          Rectangular.rrFTopRightV.pBottomRight = new Point(nX, nY);

          nX = Rectangular.nRoofWidth - Rectangular.nE10Side;
          nY = 0;
          Rectangular.rrFTopRightV.pTopLeft = new Point(nX, nY);

          nX = Rectangular.nRoofWidth;
          nY = 0;
          Rectangular.rrFTopRightV.pTopRight = new Point(nX, nY);
          Rectangular.rrFTopRightV.draw(layer);

          /* G */
          //GBottom
          Rectangular.rrGBottom = new RoofRange(Global.colDachG);
          nX = this.nE4Ver > Rectangular.nE10Side ? this.nE4Ver : Rectangular.nE10Side;
          nY = Rectangular.nRoofHeight;
          Rectangular.rrGBottom.pBottomLeft = new Point(nX, nY);

          nX = this.nE4Ver > Rectangular.nE10Side ? Rectangular.nRoofWidth - this.nE4Ver : Rectangular.nRoofWidth - Rectangular.nE10Side;
          nY = Rectangular.nRoofHeight;
          Rectangular.rrGBottom.pBottomRight = new Point(nX, nY);

          nX = this.nE4Ver > Rectangular.nE10Side ? this.nE4Ver : Rectangular.nE10Side;
          nY = Rectangular.nRoofHeight - Rectangular.nE10Ver;
          Rectangular.rrGBottom.pTopLeft = new Point(nX, nY);

          nX = this.nE4Ver > Rectangular.nE10Side ? Rectangular.nRoofWidth - this.nE4Ver : Rectangular.nRoofWidth - Rectangular.nE10Side;
          nY = Rectangular.nRoofHeight - Rectangular.nE10Ver;
          Rectangular.rrGBottom.pTopRight = new Point(nX, nY);
          Rectangular.rrGBottom.draw(layer);
          Rectangular.rrGBottom.setLabel("G");

          //GRight
          Rectangular.rrGRight = new RoofRange(Global.colDachG);
          nX = Rectangular.nRoofWidth - Rectangular.nE10Side;
          nY = this.nE4Side > Rectangular.nE10Ver ? Rectangular.nRoofHeight - this.nE4Side : Rectangular.nRoofHeight - Rectangular.nE10Ver;
          Rectangular.rrGRight.pBottomLeft = new Point(nX, nY);

          nX = Rectangular.nRoofWidth;
          nY = nY;
          Rectangular.rrGRight.pBottomRight = new Point(nX, nY);

          nX = Rectangular.nRoofWidth - Rectangular.nE10Side;
          nY = this.nE4Side > Rectangular.nE10Ver ? this.nE4Side : Rectangular.nE10Ver;
          Rectangular.rrGRight.pTopLeft = new Point(nX, nY);

          nX = Rectangular.nRoofWidth;
          nY = nY;
          Rectangular.rrGRight.pTopRight = new Point(nX, nY);
          Rectangular.rrGRight.draw(layer);
          Rectangular.rrGRight.setLabel("G");

          //GTop
          Rectangular.rrGTop = new RoofRange(Global.colDachG);
          nX = this.nE4Ver > Rectangular.nE10Side ? this.nE4Ver : Rectangular.nE10Side;
          nY = Rectangular.nE10Ver;
          Rectangular.rrGTop.pBottomLeft = new Point(nX, nY);

          nX = this.nE4Ver > Rectangular.nE10Side ? Rectangular.nRoofWidth - this.nE4Ver : Rectangular.nRoofWidth - Rectangular.nE10Side;
          nY = Rectangular.nE10Ver;
          Rectangular.rrGTop.pBottomRight = new Point(nX, nY);

          nX = this.nE4Ver > Rectangular.nE10Side ? this.nE4Ver : Rectangular.nE10Side;
          nY = 0;
          Rectangular.rrGTop.pTopLeft = new Point(nX, nY);

          nX = this.nE4Ver > Rectangular.nE10Side ? Rectangular.nRoofWidth - this.nE4Ver : Rectangular.nRoofWidth - Rectangular.nE10Side;
          nY = 0;
          Rectangular.rrGTop.pTopRight = new Point(nX, nY);
          Rectangular.rrGTop.draw(layer);
          Rectangular.rrGTop.setLabel("G");
          //GLeft
          Rectangular.rrGLeft = new RoofRange(Global.colDachG);
          nX = 0;
          nY = this.nE4Side > Rectangular.nE10Ver ? Rectangular.nRoofHeight - this.nE4Side : Rectangular.nRoofHeight - Rectangular.nE10Ver;
          Rectangular.rrGLeft.pBottomLeft = new Point(nX, nY);

          nX = Rectangular.nE10Side;
          nY = nY;
          Rectangular.rrGLeft.pBottomRight = new Point(nX, nY);

          nX = 0;
          nY = this.nE4Side > Rectangular.nE10Ver ? this.nE4Side : Rectangular.nE10Ver;
          Rectangular.rrGLeft.pTopLeft = new Point(nX, nY);

          nX = Rectangular.nE10Side;
          nY = nY;
          Rectangular.rrGLeft.pTopRight = new Point(nX, nY);
          Rectangular.rrGLeft.draw(layer);
          Rectangular.rrGLeft.setLabel("G");

          Rectangular.drawRechteckStatik(Rectangular.nRoofWidth, Rectangular.nRoofHeight, layer)

     }

     public static getRangeByModule(panel: any): string {
          if (panel && panel.length > 0) {
               var obj = panel[0];

               var farea: boolean = false, ftouch: boolean = false;
               var harea: boolean = false, htouch: boolean = false, garea: boolean = false, gtouch: boolean = false, farea: boolean = false;
               var x = obj.getAttrs().x;
               var y = obj.getAttrs().y;
               var w = obj.getAttrs().width;
               var h = obj.getAttrs().height;

               // H area range checking
               var x1, y1;
               x1 = x;
               y1 = y;
               let h1 = Statics.isModuleInRange(x1, y1, Rectangular.areaHtopLeft, Rectangular.areaHtopRight, Rectangular.areaHbottomLeft, Rectangular.areaHbottomRight);
               x1 = x + w;
               y1 = y;
               let h2 = Statics.isModuleInRange(x1, y1, Rectangular.areaHtopLeft, Rectangular.areaHtopRight, Rectangular.areaHbottomLeft, Rectangular.areaHbottomRight);
               x1 = x;
               y1 = y + h;
               let h3 = Statics.isModuleInRange(x1, y1, Rectangular.areaHtopLeft, Rectangular.areaHtopRight, Rectangular.areaHbottomLeft, Rectangular.areaHbottomRight);
               x1 = x + w;
               y1 = y + h;
               let h4 = Statics.isModuleInRange(x1, y1, Rectangular.areaHtopLeft, Rectangular.areaHtopRight, Rectangular.areaHbottomLeft, Rectangular.areaHbottomRight);
               if (h1 && h2 && h3 && h4) {
                    // console.log("panel is in H area");
                    harea = true;
               } else if (h1 || h2 || h3 || h4) {
                    htouch = true;
                    // console.log("panel is toched H area too");
               }

               let tl, tr, bl, br;
               // G area Top
               tl = Rectangular.rrGTop.pTopLeft
               tr = Rectangular.rrGTop.pTopRight
               bl = Rectangular.rrGTop.pBottomLeft
               br = Rectangular.rrGTop.pBottomRight
               x1 = x;
               y1 = y;
               let gt1 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y;
               let gt2 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x;
               y1 = y + h;
               let gt3 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y + h;
               let gt4 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               if (gt1 && gt2 && gt3 && gt4) {
                    garea = true;
                    // console.log("panel is in gTop area");
               } else if (gt1 || gt2 || gt3 || gt4) {
                    // console.log("panel is touching gTop area");
                    gtouch = true;
               }

               // G area left
               tl = Rectangular.rrGLeft.pTopLeft
               tr = Rectangular.rrGLeft.pTopRight
               bl = Rectangular.rrGLeft.pBottomLeft
               br = Rectangular.rrGLeft.pBottomRight
               x1 = x;
               y1 = y;
               let gl1 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y;
               let gl2 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x;
               y1 = y + h;
               let gl3 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y + h;
               let gl4 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               if (gl1 && gl2 && gl3 && gl4) {
                    garea = true;
                    // console.log("panel is in gleft area");
               } else if (gl1 || gl2 || gl3 || gl4) {
                    // console.log("panel is touching gleft area");
                    gtouch = true;
               }

               // G area right
               tl = Rectangular.rrGRight.pTopLeft
               tr = Rectangular.rrGRight.pTopRight
               bl = Rectangular.rrGRight.pBottomLeft
               br = Rectangular.rrGRight.pBottomRight
               x1 = x;
               y1 = y;
               let gr1 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y;
               let gr2 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x;
               y1 = y + h;
               let gr3 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y + h;
               let gr4 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               if (gr1 && gr2 && gr3 && gr4) {
                    garea = true;
                    // console.log("panel is in gright area");
               } else if (gr1 || gr2 || gr3 || gr4) {
                    // console.log("panel is touching gright area");
                    gtouch = true;
               }

               // G area bottom
               tl = Rectangular.rrGBottom.pTopLeft
               tr = Rectangular.rrGBottom.pTopRight
               bl = Rectangular.rrGBottom.pBottomLeft
               br = Rectangular.rrGBottom.pBottomRight
               x1 = x;
               y1 = y;
               let gb1 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y;
               let gb2 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x;
               y1 = y + h;
               let gb3 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y + h;
               let gb4 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               if (gb1 && gb2 && gb3 && gb4) {
                    garea = true;
                    // console.log("panel is in gBottom area");
               } else if (gb1 || gb2 || gb3 || gb4) {
                    // console.log("panel is touching gBottom area");
                    gtouch = true;
               }

               // F area 
               //   if (Rectangular.rrFBottomLeft.Statics.isModuleInRange(oMod, Rectangular.rrFBottomLeft)) {
               //        return "f";
               //    }
               tl = Rectangular.rrFBottomLeft.pTopLeft
               tr = Rectangular.rrFBottomLeft.pTopRight
               bl = Rectangular.rrFBottomLeft.pBottomLeft
               br = Rectangular.rrFBottomLeft.pBottomRight
               x1 = x;
               y1 = y;
               let fbl1 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y;
               let fbl2 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x;
               y1 = y + h;
               let fbl3 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y + h;
               let fbl4 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               if (fbl1 && fbl2 && fbl3 && fbl4) {
                    farea = true;
                    // console.log("panel is in gBottom area");
               } else if (fbl1 || fbl2 || fbl3 || fbl4) {
                    // console.log("panel is touching gBottom area");
                    ftouch = true;
               }
               //    if (Rectangular.rrFBottomLeftV.Statics.isModuleInRange(oMod, Rectangular.rrFBottomLeftV)) {
               //        return "f";
               //    }
               tl = Rectangular.rrFBottomLeftV.pTopLeft
               tr = Rectangular.rrFBottomLeftV.pTopRight
               bl = Rectangular.rrFBottomLeftV.pBottomLeft
               br = Rectangular.rrFBottomLeftV.pBottomRight
               x1 = x;
               y1 = y;
               let fblv1 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y;
               let fblv2 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x;
               y1 = y + h;
               let fblv3 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y + h;
               let fblv4 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               if (fblv1 && fblv2 && fblv3 && fblv4) {
                    farea = true;
                    // console.log("panel is in gBottom area");
               } else if (fblv1 || fblv2 || fblv3 || fblv4) {
                    // console.log("panel is touching gBottom area");
                    ftouch = true;
               }
               //    if (Rectangular.rrFBottomRight.Statics.isModuleInRange(oMod, Rectangular.rrFBottomRight)) {
               //        return "f";
               //    }
               tl = Rectangular.rrFBottomRight.pTopLeft
               tr = Rectangular.rrFBottomRight.pTopRight
               bl = Rectangular.rrFBottomRight.pBottomLeft
               br = Rectangular.rrFBottomRight.pBottomRight
               x1 = x;
               y1 = y;
               let fbr1 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y;
               let fbr2 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x;
               y1 = y + h;
               let fbr3 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y + h;
               let fbr4 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               if (fbr1 && fbr2 && fbr3 && fbr4) {
                    farea = true;
               } else if (fbr1 || fbr2 || fbr3 || fbr4) {
                    ftouch = true;
               }
               // if (Rectangular.rrFBottomRightV.Statics.isModuleInRange(oMod, Rectangular.rrFBottomRightV)) {
               //   return "f";
               // }
               tl = Rectangular.rrFBottomRightV.pTopLeft
               tr = Rectangular.rrFBottomRightV.pTopRight
               bl = Rectangular.rrFBottomRightV.pBottomLeft
               br = Rectangular.rrFBottomRightV.pBottomRight
               x1 = x;
               y1 = y;
               let fbrv1 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y;
               let fbrv2 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x;
               y1 = y + h;
               let fbrv3 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y + h;
               let fbrv4 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               if (fbrv1 && fbrv2 && fbrv3 && fbrv4) {
                    farea = true;
               } else if (fbrv1 || fbrv2 || fbrv3 || fbrv4) {
                    ftouch = true;
               }

               // if (Rectangular.rrFTopLeft.Statics.isModuleInRange(oMod, Rectangular.rrFTopLeft)) {
               //   return "f";
               // }
               tl = Rectangular.rrFTopLeft.pTopLeft
               tr = Rectangular.rrFTopLeft.pTopRight
               bl = Rectangular.rrFTopLeft.pBottomLeft
               br = Rectangular.rrFTopLeft.pBottomRight
               x1 = x;
               y1 = y;
               let ftl1 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y;
               let ftl2 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x;
               y1 = y + h;
               let ftl3 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y + h;
               let ftl4 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               if (ftl1 && ftl2 && ftl3 && ftl4) {
                    farea = true;
               } else if (ftl1 || ftl2 || ftl3 || ftl4) {
                    ftouch = true;
               }
               // if (Rectangular.rrFTopLeftV.Statics.isModuleInRange(oMod, Rectangular.rrFTopLeftV)) {
               //   return "f";
               // }
               tl = Rectangular.rrFTopLeftV.pTopLeft
               tr = Rectangular.rrFTopLeftV.pTopRight
               bl = Rectangular.rrFTopLeftV.pBottomLeft
               br = Rectangular.rrFTopLeftV.pBottomRight
               x1 = x;
               y1 = y;
               let ftlv1 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y;
               let ftlv2 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x;
               y1 = y + h;
               let ftlv3 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y + h;
               let ftlv4 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               if (ftlv1 && ftlv2 && ftlv3 && ftlv4) {
                    farea = true;
               } else if (ftlv1 || ftlv2 || ftlv3 || ftlv4) {
                    ftouch = true;
               }
               // if (Rectangular.rrFTopRight.Statics.isModuleInRange(oMod, Rectangular.rrFTopRight)) {
               //   return "f";
               // }
               tl = Rectangular.rrFTopRight.pTopLeft
               tr = Rectangular.rrFTopRight.pTopRight
               bl = Rectangular.rrFTopRight.pBottomLeft
               br = Rectangular.rrFTopRight.pBottomRight
               x1 = x;
               y1 = y;
               let ftr1 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y;
               let ftr2 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x;
               y1 = y + h;
               let ftr3 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y + h;
               let ftr4 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               if (ftr1 && ftr2 && ftr3 && ftr4) {
                    farea = true;
               } else if (ftr1 || ftr2 || ftr3 || ftr4) {
                    ftouch = true;
               }
               // if (Rectangular.rrFTopRightV.Statics.isModuleInRange(oMod, Rectangular.rrFTopRightV)) {
               //   return "f";
               // }
               tl = Rectangular.rrFTopRightV.pTopLeft
               tr = Rectangular.rrFTopRightV.pTopRight
               bl = Rectangular.rrFTopRightV.pBottomLeft
               br = Rectangular.rrFTopRightV.pBottomRight
               x1 = x;
               y1 = y;
               let ftrv1 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y;
               let ftrv2 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x;
               y1 = y + h;
               let ftrv3 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               x1 = x + w;
               y1 = y + h;
               let ftrv4 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
               if (ftrv1 && ftrv2 && ftrv3 && ftrv4) {
                    farea = true;
               } else if (ftrv1 || ftrv2 || ftrv3 || ftrv4) {
                    ftouch = true;
               }



               if (farea) return "F"
               if (garea) return "G";
               if (harea) return "H";
               if (ftouch) return "F"; else if (gtouch) return "G"; else if (htouch) return "H";
          }
          return "";
     }

     public static drawRechteckStatik(w: number, h: number, l: any): void {
          var nHWidth = w - Rectangular.nE10Side * 2;
          var nHHeight = h - Rectangular.nE10Ver * 2;

          Rectangular.areaHtopLeft = new Point(Rectangular.nE10Side, Rectangular.nE10Ver);
          Rectangular.areaHbottomLeft = new Point(Rectangular.nE10Side, nHHeight + Rectangular.nE10Ver);
          Rectangular.areaHbottomRight = new Point(nHWidth + Rectangular.nE10Side, nHHeight + Rectangular.nE10Ver);
          Rectangular.areaHtopRight = new Point(nHWidth + Rectangular.nE10Side, Rectangular.nE10Ver);

          var innearHarea = getCanvasLine({
               points: [
                    ScaleAdjustmentValue.getScaleAdjust(Rectangular.areaHtopLeft.x),
                    ScaleAdjustmentValue.getScaleAdjust(Rectangular.areaHtopLeft.y),
                    ScaleAdjustmentValue.getScaleAdjust(Rectangular.areaHtopRight.x),
                    ScaleAdjustmentValue.getScaleAdjust(Rectangular.areaHtopRight.y),
                    ScaleAdjustmentValue.getScaleAdjust(Rectangular.areaHbottomRight.x),
                    ScaleAdjustmentValue.getScaleAdjust(Rectangular.areaHbottomRight.y),
                    ScaleAdjustmentValue.getScaleAdjust(Rectangular.areaHbottomLeft.x),
                    ScaleAdjustmentValue.getScaleAdjust(Rectangular.areaHbottomLeft.y)],
               fill: SC_Input.color,
               closed: true,
               stroke: '#000000',
               strokeWidth: 2,
               opacity: 0,
               name: 'innerAreaShape'
          });
          l.add(innearHarea);
          innearHarea.draw();
     }
}
